export const MESSAGE_SENT = 'MESSAGE_SENT';
export const MESSAGE_SENT_FAILED = 'MESSAGE_SENT_FAILED';
export const SENDING_MESSAGE = 'SENDING_MESSAGE';